import { Box, Typography, Grid } from '@mui/material';

import AchievementMedallion from './AchievementMedallion';
import ProgressGauge from './ProgressGauge';

import { getCurrentTier } from './achievements';


const AchievementCard = ({ value = 0, tiers = [], icon, unit, title, description }) => {
    const currentTier = getCurrentTier(value, tiers);
    const isLocked = currentTier === null;

    if (isLocked) {
        return null;
    }

    return (
        <Grid size={{ xs: 12, sm: 6, lg: 4 }}>
            <Box
                sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    gap: 2,
                    p: 2.5,
                    borderRadius: '16px',
                    border: '1px solid',
                    borderColor: 'divider',
                    background: (theme) =>
                        `linear-gradient(145deg, ${theme.palette.background.paper} 0%, ${theme.palette.background.default} 100%)`,
                    height: '100%',
                }}
            >
                <Box sx={{ display: 'flex', gap: 2, alignItems: 'center' }}>
                    <AchievementMedallion
                        icon={icon}
                        tier={currentTier}
                        size={104}
                        shimmer={currentTier?.key === 'diamond'}
                    />
                    <Box sx={{ minWidth: 0, flex: 1 }}>
                        <Typography
                            variant="h6"
                            sx={{
                                fontWeight: 700,
                                fontSize: '1.05rem',
                                lineHeight: 1.2,
                                mb: 0.5,
                                color: isLocked ? 'text.secondary' : 'text.primary',
                            }}
                        >
                            {title}
                        </Typography>
                        <Typography
                            variant="body2"
                            sx={{ color: 'text.secondary', mb: 1.25, lineHeight: 1.45 }}
                        >
                            {description}
                        </Typography>
                    </Box>
                </Box>

                <ProgressGauge
                    value={value}
                    tiers={tiers}
                    unit={unit}
                />
            </Box>
        </Grid>
    );
};

export default AchievementCard;
